// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { PurchaseOrderLineItemsTable } from '@/purchase-order/components/purchase-order-line-items-table';
import { usePurchaseOrder } from '@/purchase-order/hooks/use-purchase-order';
import { useShipments } from '@/shipment/hooks/use-shipments';
import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/purchase-orders/$purchaseOrderKey/'
)({
  component: PurchaseOrderLineItemsTab,
});

function PurchaseOrderLineItemsTab() {
  const { purchaseOrderKey } = Route.useParams();
  const { purchaseOrder } = usePurchaseOrder(purchaseOrderKey);
  const { shipments } = useShipments({
    filter: { poNumbers: [purchaseOrder.purchaseOrderNumber] },
  });

  return (
    <HardfinTabCardWrapper title="Line items">
      <Box paddingY={2}>
        <PurchaseOrderLineItemsTable
          items={purchaseOrder.items}
          shipments={shipments}
        />
      </Box>
    </HardfinTabCardWrapper>
  );
}
